<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap"
  >
    <div
      class="back-mobile-btn"
      @click="goBack(routerBackName, 'emergencyContact')"
    >
      <i class="fa fa-arrow-left" />
    </div>
    <h3>
      {{ $t('preCheckIn.emergencyContact.title') }}
    </h3>
    <el-form
      :model="emergencyContact"
      :rules="rules"
      ref="emergencyContactForm"
      class="emergency-contact pre-reg"
      label-position="top"
    >
      <el-row class="block">
        <el-row class="title">
          {{ $t('preCheckIn.emergencyContact.formTitle') }}
        </el-row>
        <el-row class="data">
          <el-form-item
            :label="$t('common.labels.firstName')"
            prop="firstName"
            :class="[{'focus': emergencyContact.firstName}, 'required-field']"
          >
            <el-input
              type="text"
              v-model="emergencyContact.firstName"
              :value="emergencyContact.firstName"
              :disabled="emergencyContact.noEmergencyContact"
            />
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.lastName')"
            prop="lastName"
            :class="[{'focus': emergencyContact.lastName}, 'required-field']"
          >
            <el-input
              type="text"
              v-model="emergencyContact.lastName"
              :value="emergencyContact.lastName"
              :disabled="emergencyContact.noEmergencyContact"
            />
          </el-form-item>
        </el-row>
        <el-row class="data">
          <el-form-item
            :label="$t('common.labels.cellPhone')"
            prop="cellPhone"
            :class="[{'focus': emergencyContact.cellPhone}, 'required-field']"
          >
            <the-mask
              v-model="emergencyContact.cellPhone"
              :value="emergencyContact.cellPhone"
              mask="(###) ###-####"
              :disabled="emergencyContact.noEmergencyContact"
            />
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.relation')"
            prop="relation"
            :class="[{'focus': emergencyContact.relation}, 'required-field']"
          >
            <el-select
              v-if="relationships.length > 0"
              filterable
              class="full"
              v-model="emergencyContact.relation"
              placeholder=""
              :disabled="emergencyContact.noEmergencyContact"
            >
              <el-option
                v-for="(param, key) in relationships"
                :key="key"
                :label="param.name"
                :value="param.value"
              />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row class="data full">
          <el-form-item
            :class="[{'field-disabled': emergencyContact.noEmergencyContact}, 'skip-step']"
          >
            <el-checkbox
              v-model="emergencyContact.isMedicalDecisionMaker"
              :disabled="emergencyContact.noEmergencyContact"
            >
              {{ $t('preCheckIn.emergencyContact.labels.isMedical') }}
            </el-checkbox>
          </el-form-item>
        </el-row>
        <el-row class="data full">
          <el-form-item
            class="skip-step"
          >
            <el-checkbox
              v-model="emergencyContact.noEmergencyContact"
              @change="noEmergencyContact($event)"
            >
              {{ $t('preCheckIn.emergencyContact.labels.noEmergency') }}
            </el-checkbox>
          </el-form-item>
        </el-row>
      </el-row>
      <el-form-item
        class="submit-container"
      >
        <el-form-item
          class="submit-buttons"
        >
          <el-button
            @click="goBack(routerBackName, 'emergencyContact')"
            type="back"
          >
            {{ $t('common.buttons.back') }}
          </el-button>
          <el-row
            class="right-btn"
          >
            <el-button
              type="primary"
              @click="submitForm('emergencyContactForm')"
            >
              {{ $t('common.buttons.next') }}
            </el-button>
          </el-row>
        </el-form-item>
      </el-form-item>
    </el-form>
  </el-row>
</template>
<script>
import store from "../../store";

export default {
  name: 'EmergencyContact',
  data: () => {
    return {
      relationships: [],
      emergencyContact: {},
      userData: {},
      fullscreenLoading: false,
      patientNumber: null,
      loading: false,
      isLoading: false,
      activeStep: null,
      sid: null,
      routerName: 'MedicalDecisionMaker',
      routerBackName: 'AddressInfo',
      rules: {},
      fields: ['firstName', 'lastName', 'cellPhone', 'relation']
    };
  },
  watch: {
    'emergencyContact.firstName': function (val) {
      if (val && val.trim().length) this.changeField({emergencyContact_fname: val});
    },
    'emergencyContact.lastName': function (val) {
      if (val && val.trim().length) this.changeField({emergencyContact_lname: val});
    },
    'emergencyContact.cellPhone': function (val) {
      if (val && val.trim().length) this.changeField({emergencyContact_phone: val});
    },
    'emergencyContact.relation': function (val) {
      if (val && val.length) {
        let relObject = this.relationships.find(item => item.value === val),
            newVal = relObject && relObject.name ? relObject.name : '';
        if (newVal) this.changeField({emergencyContact_relation: newVal});
      }
    },
    'emergencyContact.isMedicalDecisionMaker': function (val) {
      let newValue = val ? 'true' : 'false';
      this.changeField({is_medicalDecisionMaker: newValue});
    },
    'emergencyContact.noEmergencyContact': function (val) {
      let newValue = val ? 'true' : 'false';
      this.changeField({no_emergencyContact: newValue});
    },
  },
  created () {
    this.fullscreenLoading = true;
    this.setProgressBar();
    this.setRules(this.fields);
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.patientNumber = store.getters.patientData.patientNumber;
    this.sid = this.getSessionId();
    if (!this.patientNumber) {
      this.getDataByPatientNumber().then(() => {
        this.setData();
        this.patientNumber = this.userData.patientNumber;
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    } else {
      this.setData();
    }
  },
  methods: {
    noEmergencyContact(value) {
      this.noContact(value);
    },
    setData() {
      this.saveStatisticData(this.sid, {
        active_step: this.activeStep,
        render_EmergencyContact : 'true'
      });
      this.userData = store.getters.patientData;
      this.updateUserAppData(this.userData.patientId, {
        active_pr_step: this.activeStep,
        active_route: this.$route.name
      });
      this.$axios('/Patient/GetEmergencyContactByPatientNumber', {
        method: 'GET',
        params: {
          patientNumber: this.userData.patientNumber
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          this.$set(this, 'emergencyContact', response.data.data);
        }
        this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
          pid: this.userData.patientId
        }).then((response) => {
          if (response.data) {
            if (Object.prototype.hasOwnProperty.call(response.data.appData, 'emergencyContact')) {
              this.$set(this.emergencyContact, 'noEmergencyContact', response.data.appData.emergencyContact.noEmergencyContact);
              if (this.emergencyContact.noEmergencyContact) this.noContact(true);
            } else {
              this.$set(this.emergencyContact, 'noEmergencyContact', false);
            }
          }
        });
        this.getPatientRelationships().then((response) => {
          if (response.data.isSuccess) {
            let relationsData = response.data.data;
            if (relationsData) {
              relationsData.forEach((item) => {
                item.name = this.$t('common.labels.relations.' + item.name)
                this.relationships.push(item);
              });
            }
            this.fullscreenLoading = false;
          } else {
            this.fullscreenLoading = false;
            this.setMessage(
              this.$t('common.errors.getInfo', { type: this.$t('common.labels.relation').toLowerCase() }),
              'warning'
            );
          }
        }).catch(() => {
          this.setMessage(this.$t('common.errors.getInfo', { type: this.$t('common.labels.relation').toLowerCase() }));
          this.fullscreenLoading = false;
        });
      }).catch(() => {
        this.setMessage(this.$t('common.errors.getInfo', { type: this.$t('preCheckIn.emergencyContact.formTitle').toLowerCase() }));
        this.fullscreenLoading = false;
      });
    },
    nextStep() {
      const data = {[this.activeStep] : 1};
      if (this.emergencyContact.isMedicalDecisionMaker) {
        Object.assign(data, {'medical-decision-maker': 1});
        this.routerName = 'PrimaryCarePhysician';
      }
      this.updateStepsData(this.userData.patientId, data).then((response) => {
        if (response.data.isSuccess) {
          this.updateUserAppData(this.userData.patientId, {
            emergencyContact: {
              firstName: this.emergencyContact.firstName,
              lastName: this.emergencyContact.lastName,
              cellPhone: this.emergencyContact.cellPhone,
              relation: this.emergencyContact.relation,
              isMedicalDecisionMaker: this.emergencyContact.isMedicalDecisionMaker,
              noEmergencyContact: this.emergencyContact.noEmergencyContact,
            }
          }).then((response) => {
            if (response.data) {
              if (response.data.isSuccess) {
                this.fullscreenLoading = false;
                this.$router.push({
                  name: this.routerName,
                  params: {
                    patientNumber: this.patientNumber
                  },
                });
              } else {
                this.fullscreenLoading = false;
                this.setMessage(
                  this.$t('common.errors.update', { type: this.$t('preCheckIn.emergencyContact.formTitle').toLowerCase()}),
                  'warning'
                );
              }
            }
          }).catch(() => {
            this.setMessage(this.$t('common.errors.update', { type: this.$t('preCheckIn.emergencyContact.formTitle').toLowerCase()}));
            this.fullscreenLoading = false;
          });
        }
      });
    },
    saveEmergencyContactData() {
      this.$axios('/Patient/CreateOrUpdateEmergencyContact', {
        method: 'PUT',
        data: {
          patientNumber: this.patientNumber,
          firstName: this.emergencyContact.firstName,
          lastName: this.emergencyContact.lastName,
          cellPhone: this.emergencyContact.cellPhone,
          relation: this.emergencyContact.relation,
          isMedicalDecisionMaker: this.emergencyContact.isMedicalDecisionMaker
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          this.nextStep();
        } else {
          this.fullscreenLoading = false;
          this.setMessage(this.$t('common.errors.fail'));
        }
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    },
    submitForm(formName) {
      this.fullscreenLoading = true;
      if (this.emergencyContact.noEmergencyContact) {
        this.saveStatisticData(this.sid, {
          submit_EmergencyContact: 'true'
        });
        this.nextStep();
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveStatisticData(this.sid, {
              submit_EmergencyContact: 'true'
            });
            this.saveEmergencyContactData();
          } else {
            this.fullscreenLoading = false;
            return false;
          }
        });
      }
    }
  }
};
</script>
